import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MotionSection from "../motion/MotionSection";
import MiniService from "../MiniService/index";
import "./styles.scss";

const miniServicesData = [
	{
		id: 1,
		img: "images/services/icon_s1.png",
		title: "Transporte de mercancías",
		nombre: "s1",
		description:
			"Transporte de productos terminados, carga sólida, insumos, materias primas y productos intermedios para operaciones nacionales.",
	},
	{
		id: 2,
		img: "images/services/icon_s2.png",
		title: "Transporte de consolidados",
		nombre: "s2",
		description:
			"Transporte de cupos completos y consolidación hacia y desde puertos como Cartagena, Barranquilla, Santa Marta y Buenaventura.",
	},
	{
		id: 3,
		img: "images/services/icon_s3.png",
		title: "Transporte de contenedores",
		nombre: "s3",
		description:
			"Movilización de contenedores de 20 y 40 pies desde puertos principales hacia el interior y viceversa.",
	},
	{
		id: 4,
		img: "images/services/icon_s4.png",
		title: "Transporte de última milla",
		nombre: "s4",
		description:
			"Distribución de última milla en principales ciudades del país y municipios cercanos.",
	},
	{
		id: 5,
		img: "images/services/icon_s5.png",
		title: "Operaciones in house",
		nombre: "s5",
		description:
			"Presencia operativa dentro de las instalaciones del cliente para sumar conocimiento y respuesta logística.",
	},
	{
		id: 6,
		img: "images/services/icon_s6.png",
		title: "Administración de flotas",
		nombre: "s6",
		description:
			"Análisis, optimización de corredores, administración de costos y personal para flotas propias.",
	},
];

const MiniServices = () => {
	const [activeId, setActiveId] = useState(null);

	return (
		<MotionSection className="miniServices">
			{miniServicesData.map((service) => (
				<MiniService
					key={service.id}
					data={service}
					isActive={activeId === service.id}
					onSelect={() => setActiveId((current) => (current === service.id ? null : service.id))}
				/>
			))}
		</MotionSection>
	);
};

export default MiniServices;
